import { render } from "./ForgotPasswordComplete.vue?vue&type=template&id=bb531ba6"
import script from "./ForgotPasswordComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordComplete.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/passwordReset/ForgotPasswordComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb531ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb531ba6', __exports__)) {
    console.log('reload')
    api.reload('bb531ba6', __exports__)
  }
  
  module.hot.accept("./ForgotPasswordComplete.vue?vue&type=template&id=bb531ba6", () => {
    console.log('re-render')
    api.rerender('bb531ba6', render)
  })

}


export default __exports__